<template>
    <input :maxlength="maxlength" :type="type" :name="name" :class="['fm-def', w100 ? 'w-100' : '']" :value="value" :required="required"
        :placeholder="placeholder" :readonly="readonly" @input="$emit('input', $event.target.value)" />
</template>

<script>
export default {
    props: {
        name: Boolean,
        type: { type: String, default: 'text' },
        required: Boolean,
        w100: Boolean,
        value: [String, Number],
        placeholder: String,
        readonly: Boolean,
        maxlength: Number | undefined
    },
}
</script>

<style></style>
